import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiCreditCard, FiRefreshCw } from 'react-icons/fi';
import { getActiveBillingRequests, isBillingUiEnabled } from './billingApi';
import useBillingWallet from './useBillingWallet';
import { isParentAccount } from '../mymod/accountRole';
import './BillingBalance.scss';

export default function BillingBalance({ className = '', showWalletLink = true }) {
  const { balance, data, loading, error, requiresLogin, refresh } = useBillingWallet();
  const [active, setActive] = useState(getActiveBillingRequests);
  useEffect(() => {
    const update = () => setActive(getActiveBillingRequests());
    window.addEventListener('billing:activity', update);
    return () => window.removeEventListener('billing:activity', update);
  }, []);
  if (!isBillingUiEnabled() || isParentAccount()) return null;
  return <aside className={`billing-balance-strip ${className}`.trim()} aria-label="AI 이용 잔액" aria-busy={loading || active > 0}>
    <FiCreditCard aria-hidden="true" />
    <div className="billing-balance-strip__value" aria-live="polite">
      <span>내 AI 잔액</span>
      <strong>{requiresLogin ? '로그인 필요' : data?.enabled === false ? '서비스 준비 중' : active > 0 ? 'AI 처리 중…' : loading ? '잔액 확인 중…' : error || balance === null ? '잔액 확인 필요' : `${balance.toLocaleString('ko-KR')} C`}</strong>
    </div>
    {(loading || active > 0) && <span className="billing-balance-spinner" aria-hidden="true" />}
    {requiresLogin ? <Link to="/login">로그인</Link> : showWalletLink && <Link to="/wallet">지갑 · 충전</Link>}
    {error && !requiresLogin && <button type="button" onClick={refresh} disabled={loading} aria-label="AI 잔액 다시 확인" title={error}><FiRefreshCw aria-hidden="true" /></button>}
  </aside>;
}
